export default __webpack_public_path__ + "images/0xa3fa99a148fa48d14ed51d610c367c61876997f1.png";